import { lazy, ReactNode } from 'react'
import * as constants from 'resources/constants'
import { Role } from 'resources/types'

const UsersIcon = lazy(() => import('@mui/icons-material/People'))
const ProfileIcon = lazy(() => import('@mui/icons-material/AccountCircle'))
const CompanyWebsiteIcon = lazy(() => import('@mui/icons-material/Public'))
const NotificationsIcon = lazy(() => import('@mui/icons-material/Notifications'))
const ProjectsIcon = lazy(() => import('@mui/icons-material/Construction'))
const NotificationCampaignsIcon = lazy(() => import('@mui/icons-material/AddAlert'))
const AdminSettingIcon = lazy(() => import('@mui/icons-material/AdminPanelSettings'))
const PointsReportIcon = lazy(() => import('@mui/icons-material/AssessmentOutlined'))
const TagsIcon = lazy(() => import('@mui/icons-material/LocalOffer'))
const AnalyticsIcon = lazy(() => import('@mui/icons-material/Insights'))
const MyDashboardIcon = lazy(() => import('@mui/icons-material/Speed'))

export const companyDynaicString = '__COMPANY_WEBSITE__'

export interface SidebarOptionType {
	title: string;
	icon: ReactNode;
	path?: string;
	hasChildren?: boolean;
	nested?: boolean;
	roles: Role[];
	children?: SidebarOptionType[];
	hasDividerAbove?: boolean
	hasDivderBelow?: boolean
	hideFromLanding?: boolean
}

const SidebarOptions: SidebarOptionType[] = [
	{
		title: companyDynaicString,
		icon: <CompanyWebsiteIcon />,
		path: companyDynaicString,
		roles: [Role.ACCOUNT_OWNER, Role.ADMIN, Role.EMPLOYEE, Role.CLIENT],
		hideFromLanding: true,
	},
	{
		title: 'My Dashboard',
		icon: <MyDashboardIcon />,
		path: constants.myDashboardURL,
		roles: [Role.EMPLOYEE],
	},
	{
		title: 'Projects',
		icon: <ProjectsIcon />,
		path: constants.projectsURL,
		roles: [Role.ACCOUNT_OWNER, Role.ADMIN, Role.EMPLOYEE],
	},
	{
		title: 'Notifications',
		icon: <NotificationsIcon />,
		path: constants.notificationsURL,
		roles: [Role.ACCOUNT_OWNER, Role.ADMIN, Role.EMPLOYEE, Role.CLIENT],
	},
	{
		title: 'Profile',
		icon: <ProfileIcon />,
		path: constants.profilePage,
		roles: [Role.ACCOUNT_OWNER, Role.ADMIN, Role.EMPLOYEE, Role.CLIENT],
		hasDividerAbove: true,
		hasDivderBelow: true,
	},
	{
		title: 'Users',
		icon: <UsersIcon />,
		hasChildren: true,
		roles: [Role.ACCOUNT_OWNER, Role.ADMIN],
		children: [
			{
				title: 'Manage',
				icon: <UsersIcon />,
				path: constants.manageUsersPage,
				nested: true,
				roles: [Role.ADMIN, Role.ACCOUNT_OWNER],
			},
			{
				title: 'Send Campaigns',
				icon: <NotificationCampaignsIcon />,
				path: constants.notificationCampaignsURL,
				nested: true,
				roles: [Role.ACCOUNT_OWNER, Role.ADMIN],
			},
		],
	},
	{
		title: 'Tags',
		icon: <TagsIcon />,
		path: constants.tagsURL,
		roles: [Role.ACCOUNT_OWNER, Role.ADMIN],
	},
	{
		title: 'Reports',
		icon: <PointsReportIcon />,
		path: constants.ReportsPageURL,
		roles: [Role.ACCOUNT_OWNER, Role.ADMIN],
	},
	{
		title: 'Analytics',
		icon: <AnalyticsIcon />,
		path: constants.analyticsPageURL,
		roles: [Role.ACCOUNT_OWNER, Role.ADMIN],
	},
	{
		title: 'Settings',
		icon: <AdminSettingIcon />,
		path: constants.adminSettingsURL,
		roles: [Role.ACCOUNT_OWNER, Role.ADMIN],
	},
]

export default SidebarOptions
